import {
  HomeTypeEnum,
  Icons,
  OwnershipType,
  MarketFilterParams,
  TagColor,
} from '../../enums';
import {
  FilterMinMaxItem,
  FilterTagItem,
  TagItem,
  FilterDateItem,
} from '../../types/dataTypes';
import strings from '../../language/Swedish';

const ownerTypes: TagItem[] = [
  {
    id: OwnershipType.coOperativeApartment,
    label: strings.filter.ownertypes.co_operative,
    color: TagColor.green,
  },
  {
    id: OwnershipType.propertyRights,
    label: strings.filter.ownertypes.property_right,
    color: TagColor.blue,
  },
  {
    id: OwnershipType.siteLeasehold,
    label: strings.filter.ownertypes.site_leasehold,
    color: TagColor.amber,
  },
  {
    id: OwnershipType.lease,
    label: strings.filter.ownertypes.lease,
    color: TagColor.pink,
  },
];

const housingTypes = [
  {
    id: HomeTypeEnum.apartment,
    label: strings.filter.housingTypes.apartment,
    color: TagColor.pink,
  },
  {
    id: HomeTypeEnum.house,
    label: strings.filter.housingTypes.house,
    color: TagColor.green,
  },
  {
    id: HomeTypeEnum.terracedHouse,
    label: strings.filter.housingTypes.terracedHouse,
    color: TagColor.orange,
  },
  {
    id: HomeTypeEnum.townhouse,
    label: strings.filter.housingTypes.townhouse,
    color: TagColor.cyan,
  },
  {
    id: HomeTypeEnum.farm,
    label: strings.filter.housingTypes.farm,
    color: TagColor.indigo,
  },
  {
    id: HomeTypeEnum.plot,
    label: strings.filter.housingTypes.plot,
    color: TagColor.violet,
  },
];

const filterItems: {
  tagItems: FilterTagItem[];
  minMaxItems: FilterMinMaxItem[];
  dateItems: FilterDateItem[];
  checkboxItems: CheckboxItem[];
} = {
  tagItems: [
    {
      id: MarketFilterParams.ownership_type,
      label: strings.filter.owner,
      icon: Icons.key,
      items: ownerTypes,
    },
    {
      id: MarketFilterParams.homeType,
      label: strings.filter.housingType,
      icon: Icons.house,
      items: housingTypes,
    },
  ],
  minMaxItems: [
    {
      minId: MarketFilterParams.rooms_min,
      maxId: MarketFilterParams.rooms_max,
      label: strings.filter.rooms,
      icon: Icons.bed,
      valueLabel: '',
      min: 0,
      max: 10,
    },
    {
      minId: MarketFilterParams.living_area_min,
      maxId: MarketFilterParams.living_area_max,
      label: strings.filter.living_area,
      icon: Icons.area,
      valueLabel: 'm\u00B2',
      min: 0,
      max: 500,
    },
    {
      minId: MarketFilterParams.price_min,
      maxId: MarketFilterParams.price_max,
      label: strings.filter.price,
      icon: Icons.coins,
      valueLabel: 'mkr',
      min: 0,
      max: 40,
      type: 'decimal',
    },
    {
      minId: MarketFilterParams.monthly_fee_min,
      maxId: MarketFilterParams.monthly_fee_max,
      label: strings.filter.monthly_fee,
      icon: Icons.dollar,
      valueLabel: 'SEK',
      min: 0,
      max: 12000,
    },
    {
      minId: MarketFilterParams.construction_year_min,
      maxId: MarketFilterParams.construction_year_max,
      label: strings.filter.construction_year,
      icon: Icons.crane,
      valueLabel: '',
      min: 1850,
      max: 2024,
    },
  ],
  dateItems: [
    {
      minId: MarketFilterParams.registered_date_min,
      maxId: MarketFilterParams.registered_date_max,
      label: strings.filter.registeredDate,
      icon: Icons.calendar,
      valueLabel: '',
      startDate: new Date(new Date().setFullYear(new Date().getFullYear() - 1)),
      endDate: new Date(),
    },
  ],
  checkboxItems: [],
};

export { filterItems };
